(function () {
  'use strict';

  var root = document.querySelector('[data-sp-hsearch]');
  if (!root) return;
  var area = root.closest('.logo-area');
  var header = root.closest('.pageheader') || area;
  var form = root.querySelector('.sp-hsearch__field');
  var input = root.querySelector('.sp-hsearch__input');
  var closeBtn = root.querySelector('.sp-hsearch__close');
  var panel = root.querySelector('.sp-hsearch__panel');
  var idle = root.querySelector('[data-sp-hs-idle]');
  var results = root.querySelector('[data-sp-hs-results]');
  var shade = document.querySelector('[data-sp-hsearch-shade]');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia('(max-width: 767.98px)');

  var isOpen = false;
  var trigger = null;
  var active = -1;
  var timer = 0;
  var aborter = null;
  var lastQuery = '';

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
  }

  /* The phone field is narrower than the tablet-and-up one, so it carries its
     own shorter placeholder. Keyed to the same media query as the layout. */
  var placeholderWide = input.getAttribute('placeholder') || '';
  var placeholderPhone = input.getAttribute('data-placeholder-phone') || placeholderWide;
  function placeholder() {
    input.setAttribute('placeholder', phone.matches ? placeholderPhone : placeholderWide);
  }
  placeholder();

  function layout() {
    var a = area.getBoundingClientRect();
    var left, right;
    if (phone.matches) {
      // The phone trigger stays put and doubles as the field's leading icon, so
      // the field begins just past it rather than running underneath it.
      var phoneTrigger = area.querySelector('.logo-area__left__inner .show-search-link');
      left = (visible(phoneTrigger) ? phoneTrigger.getBoundingClientRect().right + 4 : a.left + 16);
      right = a.right - 16;
    } else {
      // The links a shopper sees are #main-nav's, laid over #proxy-nav (a hidden copy
      // inside .logo-area that only reserves their space).
      var navList = document.querySelector('#main-nav .navigation__tier-1');
      var toggle = area.querySelector('.logo-area__left .mobile-nav-toggle');
      var logo = area.querySelector('.logo-area__middle');
      // The field stops before the LEFTMOST icon on screen, the trigger included:
      // since r230 the magnifier sits first (CSS order: -1, DOM order unchanged),
      // so stopping at the account icon ran the field and its close button under it.
      var rightIcons = [].slice.call(area.querySelectorAll('.logo-area__right__inner > *')).filter(visible);
      right = rightIcons.reduce(function (min, el) {
        return Math.min(min, el.getBoundingClientRect().left);
      }, a.right) - 24;
      var links = navList ? [].slice.call(navList.querySelectorAll('.navigation__link')).filter(visible) : [];
      if (links.length) {
        // Desktop: the field takes the nav's run, from its first link to the icons.
        left = links[0].getBoundingClientRect().left;
        var wordmark = logo && logo.querySelector('a');
        if (wordmark && visible(wordmark)) left = Math.max(left, wordmark.getBoundingClientRect().right + 40);
      } else {
        left = (visible(toggle) ? toggle.getBoundingClientRect().right : a.left) + 16;
      }
    }
    root.style.setProperty('--sp-hs-left', Math.round(left - a.left) + 'px');
    root.style.setProperty('--sp-hs-width', Math.max(200, Math.round(right - left)) + 'px');
    root.style.setProperty('--sp-hs-top', Math.round(a.bottom) + 'px');
    if (shade) shade.style.top = Math.round(a.bottom) + 'px';
  }

  function open(fromLink) {
    if (isOpen) return;
    isOpen = true;
    trigger = fromLink;
    layout();
    header.classList.add('sp-hsearch-open');
    document.body.classList.add('sp-hsearch-body-open');
    if (phone.matches) document.documentElement.classList.add('sp-hsearch-lock');
    input.tabIndex = 0;
    closeBtn.tabIndex = 0;
    // Focus inside the same gesture so phones raise the keyboard.
    input.focus({ preventScroll: true });
    showPanel();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    hidePanel();
    header.classList.remove('sp-hsearch-open');
    document.body.classList.remove('sp-hsearch-body-open');
    document.documentElement.classList.remove('sp-hsearch-lock');
    input.tabIndex = -1;
    closeBtn.tabIndex = -1;
    input.blur();
    if (trigger) trigger.focus({ preventScroll: true });
  }

  function showPanel() {
    panel.classList.add('is-visible');
    if (shade) shade.classList.add('is-visible');
    input.setAttribute('aria-expanded', 'true');
  }

  function hidePanel() {
    panel.classList.remove('is-visible');
    if (shade) shade.classList.remove('is-visible');
    input.setAttribute('aria-expanded', 'false');
    active = -1;
  }

  /* ---- autocomplete ----------------------------------------------------- */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function mark(text, q) {
    var t = esc(text);
    var words = q.trim().split(/\s+/).filter(Boolean).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!words.length) return t;
    return t.replace(new RegExp('(' + words.map(esc).join('|') + ')', 'ig'), '<mark>$1</mark>');
  }

  var money = (function () {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      var f = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur });
      return function (v) { return f.format(parseFloat(v)); };
    } catch (e) {
      return function (v) { return '$' + parseFloat(v).toFixed(2); };
    }
  })();

  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ?q=<term> and nothing else — see the snippet's note on why options[prefix]
     was dropped rather than just encoded more tidily. */
  function searchUrl(q) {
    /* '+' for spaces, not %20: both are valid in a query string and Shopify
       reads either, but the form's own GET submit produces '+', so matching it
       means a suggestion link and a typed search land on the SAME url — one
       history entry, one thing to share, one cache key. */
    return form.getAttribute('action') + '?q=' + encodeURIComponent(q).replace(/%20/g, '+');
  }

  function render(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [];
    var collections = r.collections || [];
    var pages = (r.pages || []).concat(r.articles || []);
    var queries = (r.queries || []).filter(function (x) { return x.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 5);

    if (!products.length && !collections.length && !pages.length && !queries.length) {
      results.innerHTML =
        '<div class="sp-hsearch__empty"><p>Nothing matches <strong>' + esc(q) + '</strong> yet.</p>' +
        '<p>Try a shorter word, or <a data-sp-hs-item href="/collections/new-arrivals">browse new arrivals</a>.</p></div>';
      return;
    }

    var side = '';
    if (queries.length) {
      side += '<div class="sp-hsearch__group"><p class="sp-hsearch__label">Suggestions</p><ul class="sp-hsearch__list">' +
        queries.map(function (x) {
          return '<li><a class="sp-hsearch__suggest" data-sp-hs-item role="option" href="' + searchUrl(x.text) + '">' + mark(x.text, q) + '</a></li>';
        }).join('') + '</ul></div>';
    }
    if (collections.length) {
      side += '<div class="sp-hsearch__group"><p class="sp-hsearch__label">Collections</p><ul class="sp-hsearch__list">' +
        collections.slice(0, 4).map(function (c) {
          return '<li><a data-sp-hs-item role="option" href="' + esc(c.url) + '">' + mark(c.title, q) + '</a></li>';
        }).join('') + '</ul></div>';
    }
    if (pages.length) {
      side += '<div class="sp-hsearch__group"><p class="sp-hsearch__label">Pages and stories</p><ul class="sp-hsearch__list">' +
        pages.slice(0, 3).map(function (p) {
          return '<li><a data-sp-hs-item role="option" href="' + esc(p.url) + '">' + mark(p.title, q) + '</a></li>';
        }).join('') + '</ul></div>';
    }

    var grid = '';
    if (products.length) {
      grid = '<div class="sp-hsearch__products"><p class="sp-hsearch__label">Products</p><ul class="sp-hsearch__grid">' +
        products.slice(0, 8).map(function (p) {
          var src = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          var sale = parseFloat(p.compare_at_price_max) > parseFloat(p.price);
          return '<li><a class="sp-hsearch__product" data-sp-hs-item role="option" href="' + esc(p.url) + '">' +
            '<span class="sp-hsearch__thumb">' + (src ? '<img src="' + esc(img(src, 360)) + '" alt="" loading="lazy" width="180" height="180">' : '') + '</span>' +
            '<span class="sp-hsearch__meta">' +
              (p.vendor ? '<span class="sp-hsearch__vendor">' + esc(p.vendor) + '</span>' : '') +
              '<span class="sp-hsearch__title">' + mark(p.title, q) + '</span>' +
              '<span class="sp-hsearch__price">' + (sale ? '<s>' + money(p.compare_at_price_max) + '</s> ' : '') + money(p.price) +
                (p.available === false ? ' <em>Sold out</em>' : '') + '</span>' +
            '</span></a></li>';
        }).join('') + '</ul></div>';
    }

    results.innerHTML =
      '<div class="sp-hsearch__layout">' +
        (side ? '<div class="sp-hsearch__side">' + side + '</div>' : '') +
        grid +
      '</div>' +
      '<a class="sp-hsearch__all" data-sp-hs-item href="' + searchUrl(q) + '">View all results for “' + esc(q) + '”</a>';
  }

  function query() {
    var q = input.value.trim();
    if (q === lastQuery) return;
    lastQuery = q;
    clearTimeout(timer);
    if (aborter) { aborter.abort(); aborter = null; }
    active = -1;
    if (!q) {
      root.classList.remove('has-query', 'is-loading');
      results.innerHTML = '';
      return;
    }
    root.classList.add('has-query', 'is-loading');
    timer = setTimeout(function () {
      aborter = new AbortController();
      var url = new URL((window.theme && theme.routes && theme.routes.predictiveSearch ? theme.routes.predictiveSearch : '/search/suggest') + '.json', window.location.origin);
      url.searchParams.set('q', q);
      url.searchParams.set('resources[type]', 'product,collection,page,article,query');
      url.searchParams.set('resources[limit]', '8');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      fetch(url, { signal: aborter.signal, headers: { Accept: 'application/json' } })
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (data) {
          aborter = null;
          if (input.value.trim() !== q) return;
          root.classList.remove('is-loading');
          render(q, data);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          root.classList.remove('is-loading');
          results.innerHTML = '<div class="sp-hsearch__empty"><p>Search is taking a moment. <a data-sp-hs-item href="' + searchUrl(q) + '">See all results for “' + esc(q) + '”</a>.</p></div>';
        });
    }, 160);
  }

  function items() {
    var scope = root.classList.contains('has-query') ? results : idle;
    return [].slice.call(scope.querySelectorAll('[data-sp-hs-item]'));
  }

  function move(step) {
    var list = items();
    if (!list.length) return;
    active = (active + step + list.length) % list.length;
    list.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
    list[active].scrollIntoView({ block: 'nearest' });
  }

  /* ---- wiring ----------------------------------------------------------- */

  document.addEventListener('click', function (evt) {
    var link = evt.target.closest && evt.target.closest('.show-search-link');
    if (!link || !area.contains(link)) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    if (isOpen) close(); else open(link);
  }, true);

  closeBtn.addEventListener('click', close);
  if (shade) shade.addEventListener('click', close);
  input.addEventListener('input', query);
  input.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') { evt.preventDefault(); close(); }
    else if (evt.key === 'ArrowDown') { evt.preventDefault(); move(1); }
    else if (evt.key === 'ArrowUp') { evt.preventDefault(); move(-1); }
    else if (evt.key === 'Enter' && active > -1) {
      var list = items();
      if (list[active]) { evt.preventDefault(); list[active].click(); }
    }
  });
  form.addEventListener('submit', function (evt) {
    if (!input.value.trim()) evt.preventDefault();
  });
  document.addEventListener('keydown', function (evt) {
    if (isOpen && evt.key === 'Escape') close();
  });
  window.addEventListener('resize', function () { if (isOpen) layout(); });
  phone.addEventListener && phone.addEventListener('change', function () { placeholder(); if (isOpen) close(); });
})();
